import { useEffect, useState } from 'react';

/*
  Today's invoiced and sold totals for the "Today" cards of the palette (GET /api/metrics/topbar-summary, AdminFull only).
  Loaded every time the palette opens; the last answer is kept for the rest of the day, so reopening shows the
  figures at once while they refresh.
*/

const today = () => new Date().toDateString();

let last = null; // { userId, day, stats }

export function useDayStats(userId, enabled) {
  const [stats, setStats] = useState(() => (enabled && last?.userId === userId && last.day === today() ? last.stats : null));
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    fetch('/api/metrics/topbar-summary')
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        last = { userId, day: today(), stats: data };
        if (active) setStats(data);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [userId, enabled]);

  return { stats, failed };
}
